import styles from "./Questionnaire.module.css";
import { useDispatch, useSelector } from "react-redux";
import { useState, useEffect } from "react";
import * as driverightActions from "../../../store/actions/driveright";
import { useHistory } from "react-router-dom";
import YesNo from "./yes-no/YesNo";
import { baseTitle } from "../../../constants/messages";

function Questionnaire() {
  const dispatch = useDispatch();
  const history = useHistory();
  let [needResend, setNeedResend] = useState(false);
  let [newDevice, setNewDevice] = useState(false);
  let aysUser = useSelector((state) => state.user.agentInfo);

  const handleSubmit = () => {
    if (needResend) {
      aysUser
        ? dispatch(driverightActions.sendCode(newDevice)).then(
            history.push("/mlumpolicies")
          )
        : dispatch(driverightActions.sendCode(newDevice)).then(
            history.push("/operators")
          );
    } else {
      close();
    }
  };

  const close = () => {
    aysUser ? history.push("/mlumpolicies") : history.push("/operators");
  };

  useEffect(() => {
    document.title = baseTitle + " - DriveSteady Activation Code";
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.questions}>
        <YesNo
          question="Does the insured need the activation code resent?"
          group="resend"
          handler={setNeedResend}
          value={needResend}
        />
        <YesNo
          question=" Did the insured purchase a new mobile device?"
          group="newDevice"
          handler={setNewDevice}
          value={newDevice}
        />
      </div>
      <div className={styles.buttons}>
        <button className={styles.button} onClick={handleSubmit}>
          Submit
        </button>
        <button className={styles.button} onClick={close}>
          Close
        </button>
      </div>
    </div>
  );
}

export default Questionnaire;
